const state = {
    personal_details: {
        details: {},
        address: {
            current: {},
            previous: {},
            mailing: {},
        },
        contact: {},
    },
};

const getters = {
    personalDetailsState: (state) => state.personal_details,
};

const actions = {
    async doGetPersonalDetails({ commit, rootState }) {
        let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
        return new Promise((resolve, reject) => {
            axios.get("/user/" + userId + "/details/personal").then(
                (response) => {
                    if (response.data.first_name != undefined) {
                        // We're double checking if the response has data before committing, as the personal details row may not yet exist in the database
                        commit("setPersonalDetails", response.data);
                    }
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doUpdatePersonalDetails({ commit, rootState }, personalDetails) {
        if (this.throttle) clearTimeout(this.throttle); // Simple debouncing technique
        this.throttle = setTimeout(() => {
            let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
            return new Promise((resolve, reject) => {
                let details = Object.assign({}, personalDetails);
                console.log("doUpdatePersonalDetails", details);
                axios.patch("/user/" + userId + "/details/personal", details).then(
                    (response) => {
                        commit("setPersonalDetails", response.data);
                        resolve(response);
                    },
                    (error) => {
                        console.log(error);
                        reject(error);
                    }
                );
            });
        }, 500);
    },
    async doUpdateAddressDetails({ commit, rootState }, addressDetails) {
        if (this.throttle) clearTimeout(this.throttle); // Simple debouncing technique
        this.throttle = setTimeout(() => {
            let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
            return new Promise((resolve, reject) => {
                axios.patch("/user/" + userId + "/details/address", addressDetails).then(
                    (response) => {
                        commit("setAddressDetails", response.data);
                        resolve(response);
                    },
                    (error) => {
                        console.log(error);
                        reject(error);
                    }
                );
            });
        }, 500);
    },
    async doGetAddressDetails({ commit, rootState }) {
        let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
        return new Promise((resolve, reject) => {
            axios.get("/user/" + userId + "/details/address").then(
                (response) => {
                    commit("setAddressDetails", response.data);
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doGetContactDetails({ commit, rootState }) {
        let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
        return new Promise((resolve, reject) => {
            axios.get("/user/" + userId + "/details/contact").then(
                (response) => {
                    if (response.data.length) {
                        // Only set state if there is a value in the response
                        commit("setContactDetails", response.data);
                    }
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doUpdateContactDetails({ commit, rootState }, contactDetails) {
        if (this.throttle) clearTimeout(this.throttle); // Simple debouncing technique
        this.throttle = setTimeout(() => {
            let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
            return new Promise((resolve, reject) => {
                axios.patch("/user/" + userId + "/details/contact", contactDetails).then(
                    (response) => {
                        commit("setContactDetails", response.data);
                        resolve(response);
                    },
                    (error) => {
                        console.log(error);
                        reject(error);
                    }
                );
            });
        }, 500);
    },
    async doClearAddressDetails({ commit, dispatch, rootState }, addressTypeToClear) {
        console.log("addressTypeToClear", addressTypeToClear);
        commit("clearAddressDetails", addressTypeToClear);
    },
};
const mutations = {
    setPersonalDetails: (state, personalDetails) => {
        state.personal_details.details = personalDetails;
    },
    setAddressDetails: (state, addressDetails) => {
        Object.keys(addressDetails).map((key) => {
            state.personal_details.address = {
                ...state.personal_details.address,
                [key]: addressDetails[key],
            };
        });
    },
    setContactDetails: (state, contactDetails) => {
        state.personal_details.contact = contactDetails;
    },
    clearAddressDetails: (state, addressTypeToClear) => {
        state.personal_details.address = {
            ...state.personal_details.address,
            [addressTypeToClear]: {},
        };
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
